import './Loader.css';
import { defineComponent as d, openBlock as s, createElementBlock as a, createElementVNode as i, normalizeClass as o, createCommentVNode as n } from "vue";
const g = {
  class: /* @__PURE__ */ o(["loader"])
}, c = ["src"], h = ["src"], k = /* @__PURE__ */ d({
  __name: "Loader",
  props: {
    logoLight: { default: "https://images.web3auth.io/web3auth-logo-w.svg" },
    logoDark: { default: "https://images.web3auth.io/web3auth-logo-w-light.svg" },
    showLogo: { type: Boolean, default: !1 },
    classes: { default: () => ({}) }
  },
  setup(m) {
    return (e, u) => {
      var l, t, r;
      return s(), a("div", g, [
        i("div", {
          class: o(["loader-spinner", (l = e.classes) == null ? void 0 : l.spinner])
        }, null, 2),
        e.showLogo ? (s(), a("img", {
          key: 0,
          class: o(["hidden dark:block", ["loader-image", (t = e.classes) == null ? void 0 : t.logo]]),
          src: e.logoDark,
          alt: "Loader"
        }, null, 10, c)) : n("", !0),
        e.showLogo ? (s(), a("img", {
          key: 1,
          class: o(["block dark:hidden", ["loader-image", (r = e.classes) == null ? void 0 : r.logo]]),
          src: e.logoLight,
          alt: "Loader"
        }, null, 10, h)) : n("", !0)
      ]);
    };
  }
});
export {
  k as _
};
//# sourceMappingURL=Loader.vue_vue_type_style_index_0_lang-BR_U7Gl-.js.map
